/* © ИП Коробкин И.Н., KIN DIGITAL CRM+ */
/** Проверка контрольных сумм ИНН и ОГРН. */
export function isValidInn(inn: string): boolean {
  if (!/^\d{10}$|^\d{12}$/.test(inn)) return false;
  const d = inn.split('').map(Number);
  const chk = (w: number[]) => (w.reduce((s, k, i) => s + k * d[i], 0) % 11) % 10;
  if (d.length === 10) return chk([2, 4, 10, 3, 5, 9, 4, 6, 8]) === d[9];
  return chk([7, 2, 4, 10, 3, 5, 9, 4, 6, 8]) === d[10] && chk([3, 7, 2, 4, 10, 3, 5, 9, 4, 6, 8]) === d[11];
}

export function isValidOgrn(ogrn: string): boolean {
  if (/^\d{13}$/.test(ogrn)) return Number(BigInt(ogrn.slice(0, 12)) % 11n % 10n) === Number(ogrn[12]);
  if (/^\d{15}$/.test(ogrn)) return Number(BigInt(ogrn.slice(0, 14)) % 13n % 10n) === Number(ogrn[14]);
  return false;
}

export function normalizePhone(p: string): string {
  const digits = p.replace(/\D/g, '');
  if (digits.length === 11 && (digits[0] === '8' || digits[0] === '7')) return '+7' + digits.slice(1);
  if (digits.length === 10) return '+7' + digits;
  return digits ? '+' + digits : '';
}
